import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './index.css';
import App from './App';
import Footer from './components/partial/Footer';
import { StatCheckerPage } from './pageDefinitions';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/statChecker",
    element: <StatCheckerPage />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="is-flex-direction-column hero is-fullheight">
      <div className="ml-2 mr-2 pr- mt-4 p-0 is-align-self-center is-fullheight">
         <RouterProvider router={router} />
      </div>
      <Footer></Footer>
    </div>
  </React.StrictMode>
);

